import { render, staticRenderFns } from "./DocumentPendingList.vue?vue&type=template&id=147c93c5&"
import script from "./DocumentPendingList.vue?vue&type=script&lang=js&"
export * from "./DocumentPendingList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPendingList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports